<template>
  <div>
    <v-container
      fluid>
      <v-row
        justify=end>
        <v-btn
          rounded
          outlined
          color="primary"
          @click="$router.push({name: 'students', params: {'id': parent.uuid}})">
          お子さま一覧へ
        </v-btn>
      </v-row>
    </v-container>
  <v-container
    fluid>
    <v-student-profile-setting-card
      v-model="inputValue"
      @submit-button-click="createStudent"
      @add-schedule-button-click="addNewSchedule"
      @delete-schedule-button-click="deleteSchedule"
      />
    <v-student-profile-set-dialog
      :enable="dialog"
      @students-button-click="toStudents"
      />
    <v-dialog
      :value="errorDialog"
      width="500">
      <v-card>
        <v-container
          fluid>
          <v-row
            justify=center>
            <v-col
              class="font-weight-bold red--text main--text">
              {{ createError }}
            </v-col>
          </v-row>
          <v-row
            justify=center>
            <v-btn
              outlined
              rounded
              class="main--text"
              @click="errorDialog=false">
              OK
            </v-btn>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </v-container>
  </div>
</template>

<script>
import { firestore } from "@/repository/client/firestore.js"
import { ParentRepository } from "@/repository/ParentRepository.js"
import { StudentRepository } from "@/repository/StudentRepository.js"
import VStudentProfileSettingCard from "@/components/organisms/parent/VStudentProfileSettingCard.vue"
import VStudentProfileSetDialog from "@/components/organisms/parent/VStudentProfileSetDialog.vue"

export default {
  components: {
    VStudentProfileSettingCard,
    VStudentProfileSetDialog
  },
  data () {
    return {
      parent: null,
      inputValue: {
        birthday: new Date(2003,0,1),
        availableSchedules: [{}]
      },
      dialog: false,
      createError: null,
      errorDialog: false
    }
  },
  methods: {
    async createStudent() {
      try {
        const student = await this.studentRepo.put({
          parentId: this.parent.uuid,
          personalName: this.inputValue.personalName,
          familyName: this.parent.name.familyName,
          flatPersonalName: this.inputValue.flatPersonalName,
          flatFamilyName: this.parent.name.flatFamilyName,
          gender: this.inputValue.gender,
          birthday: this.inputValue.birthday,
          availableSchedules: this.inputValue.availableSchedules,
          address: this.parent.address,
          nearestStation: this.parent.nearestStation
        }
        )
        this.parent = await this.updateStudentsOfParent(student)
        this.$store.commit("loginAsParent", this.parent)
        this.dialog = true
      } catch(e) {
        if (e instanceof RangeError) {
          this.createError = "小学生から高校生までに該当する年齢の方のみ登録可能です"
        } else {
          this.createError = "入力エラーが発生しました"
        }
        this.errorDialog = true
      }
    },
    async updateStudentsOfParent(student) {
      this.parent = await this.parentRepo.update(this.parent.registerStudent(student))
      return this.parent
    },
    addNewSchedule () {
      this.inputValue.availableSchedules.push({})
    },
    deleteSchedule(index) {
      if (this.inputValue.availableSchedules.length > 1) {
        this.inputValue.availableSchedules.splice(index, 1)
      }
    },
    toMyPage() {
      this.$router.push({
        name: "parentMyPage",
        params: { id: this.$store.getters.parent.uuid }
      })
    },
    toStudents() {
      this.$router.push({
        name: "students",
        params: { id: this.$store.getters.parent.uuid }
      })
    }
  },
  created: function () {
    this.parentRepo = new ParentRepository(firestore)
    this.studentRepo = new StudentRepository(firestore)
    this.parent = this.$store.getters.parent
  }
}
</script>

